import { createContext, ReactNode, memo } from 'react'
import { TConnects, createUseSocket, createUseSocketListener } from '../createWebSocket'
import {
  createGetSocketMessageIdAndData,
  createGenerateMessageId,
  sendMessageHandler,
} from './getTradeSocketMessageIdAndData'
import getTimezone from '../../utils/getTimezone'
import { useWebSocketURL } from '../useWebSocketURL'

const TradeSocketContext = createContext<TConnects | undefined>(undefined)

const sendPingHandler = (socket: WebSocket) => {
  socket.send(
    JSON.stringify({
      ping: 'ping', // tmd: 这鸡吧现货和合约的ping字段不一样，操
    })
  )
}

type TSocketProviderProps = {
  children: ReactNode
}
export const TradeSocketProvider = memo(({ children }: TSocketProviderProps) => {
  let timezone = getTimezone()
  const { tradeWsURL: wsURL } = useWebSocketURL()

  const generateMessageId = createGenerateMessageId(timezone)
  return (
    <TradeSocketContext.Provider
      value={{
        wsURL,
        subscribeData: {},
        socket: null,
        // messageDataHandler: createContractMessageDataHandler(timezone),
        getSocketMessageIdAndData: createGetSocketMessageIdAndData(timezone),
        generateMessageId,
        sendMessageHandler,
        sendPingHandler,
      }}
    >
      {children}
    </TradeSocketContext.Provider>
  )
})

TradeSocketProvider.displayName = 'TradeSocketProvider'

export const useTradeSocket = createUseSocket(TradeSocketContext)
export const useSocketListener = createUseSocketListener(TradeSocketContext)
